import { render, staticRenderFns } from "./SalaryPay.vue?vue&type=template&id=01d26aac&scoped=true"
import script from "./SalaryPay.vue?vue&type=script&lang=js"
export * from "./SalaryPay.vue?vue&type=script&lang=js"
import style0 from "./SalaryPay.vue?vue&type=style&index=0&id=01d26aac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d26aac",
  null
  
)

export default component.exports